import { useEffect, useState } from 'react';
import { useConfiguration } from '../../../context/configurationContext';
import { denormalisedResponseEntities } from '../../../util/data';
import { createImageVariantConfig } from '../../../util/sdkLoader';

export const useGetOwnListings = id => {
  const [isLoading, setLoading] = useState(true);
  const [listingFetched, setListingFetched] = useState(null);
  const [imagesFetched, setImagesFetched] = useState(null);
  const config = useConfiguration();

  const getListing = async () => {
    const {
      aspectWidth = 1,
      aspectHeight = 1,
      variantPrefix = 'listing-card',
    } = config?.layout?.listingImage;
    const aspectRatio = aspectHeight / aspectWidth;
    setLoading(true);
    const results = await window?.app?.sdk.ownListings
      .query({
        subject_id: id,
        include: ['images'],
        'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
        ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      })
      .then(response => {
        const result = denormalisedResponseEntities(response);
        console.log('R:', result, response);
        const findPublicListing = result?.find(listing => {
          return (
            listing?.attributes?.state === 'published' || listing?.attributes?.state === 'draft'
          );
        });

        setListingFetched(findPublicListing);
        setLoading(false);

        const images = response?.data?.included?.filter(item => item.type === 'image');
        setImagesFetched(images);
      });

    return results;
  };

  useEffect(() => {
    if (id) getListing();
  }, [id]);

  return { listingFetched, imagesFetched, isLoading, refetch: getListing };
};
